import {
  FRIENZZI_BOT_UID as BOT_UID,
  FRIENZZI_BOT_USERNAME,
} from '@/src/features/bot/bot-identity';

export type ProfileMentionLike = {
  label: string;
  uid: string;
};

export const FRIENZZI_BOT_MENTION_LABEL = `@${FRIENZZI_BOT_USERNAME}`;
export const FRIENZZI_BOT_UID = BOT_UID;

export function frienzziBotMentionLabelInText(body: string) {
  const match = /(^|[^A-Za-z0-9_])(@frienzzi\b)/i.exec(body);

  return match?.[2] ?? null;
}

export function profileMentionsForText<TMention extends ProfileMentionLike>(
  body: string,
  mentions: TMention[] | undefined,
  maxMentions = 20,
) {
  const cappedMaxMentions = Math.max(1, Math.floor(maxMentions));
  const seen = new Set<string>();
  const validMentions: ProfileMentionLike[] = [];

  mentions?.forEach((mention) => {
    const uid = mention.uid.trim();
    const label = mention.label.trim();
    const key = `${uid}:${label}`;

    if (
      !uid ||
      !label ||
      label.length > 90 ||
      !body.includes(label) ||
      seen.has(key)
    ) {
      return;
    }

    seen.add(key);
    validMentions.push({ uid, label });
  });

  const botLabel = frienzziBotMentionLabelInText(body);

  if (botLabel) {
    const botKey = `${FRIENZZI_BOT_UID}:${botLabel}`;

    if (!seen.has(botKey)) {
      seen.add(botKey);
      validMentions.push({ uid: FRIENZZI_BOT_UID, label: botLabel });
    }
  }

  const cappedMentions = validMentions.slice(0, cappedMaxMentions);

  if (
    botLabel &&
    !cappedMentions.some((mention) => mention.uid === FRIENZZI_BOT_UID)
  ) {
    cappedMentions[cappedMentions.length - 1] = {
      uid: FRIENZZI_BOT_UID,
      label: botLabel,
    };
  }

  return cappedMentions;
}
